/*
 * @author: wayou
 * @date: 2018-10-12 10:57:45
 * @description: 滑动处理
 *
 * usage:
 *
 * ```js
 * const swipe = new Swipe('.slider');
 * swipe.onSwipeLeft(()=> console.log('swipe left'));
 * ```
 *
 */

export default class Swipe {
    private element: HTMLElement | null = null;
    private touchStartX: number = 0;
    private touchStartY: number = 0;
    private touchEndX: number   = 0;
    private touchEndY: number   = 0;
    private sensitive: number   = 50;
    private onSwipeLeftAgent?: () => void;
    private onSwipeRightAgent?: () => void;
    private onSwipeUpAgent?: () => void;
    private onSwipeDownAgent?: () => void;
    private onTapAgent?: () => void;

    constructor(selector: string) {
        this.element = document.querySelector(selector);
        if (this.element) {
            this.element.addEventListener(
                'touchstart',
                this.onTouchStart,
                false,
            );
            this.element.addEventListener('touchend', this.onTouchEnd, false);
        }
    }

    public onTouchStart = (event: TouchEvent) => {
        this.touchStartX = event.changedTouches[0].screenX;
        this.touchStartY = event.changedTouches[0].screenY;
    }

    public onTouchEnd = (event: TouchEvent) => {
        this.touchEndX = event.changedTouches[0].screenX;
        this.touchEndY = event.changedTouches[0].screenY;
        this.handleGesture();
    }

    public onSwipeLeft = (callback: () => void) => {
        this.onSwipeLeftAgent = callback;
    }
    public onSwipeRight = (callback: () => void) => {
        this.onSwipeRightAgent = callback;
    }
    public onSwipeUp = (callback: () => void) => {
        this.onSwipeUpAgent = callback;
    }
    public onSwipeDown = (callback: () => void) => {
        this.onSwipeDownAgent = callback;
    }
    public onTap = (callback: () => void) => {
        this.onTapAgent = callback;
    }

    public destroy = () => {
        if (this.element) {
            this.element.removeEventListener('touchstart', this.onTouchStart);
            this.element.removeEventListener('touchend', this.onTouchEnd);
        }
    }

    public handleGesture = () => {
        // swiped left
        if (this.touchEndX + this.sensitive <= this.touchStartX) {
            if (this.onSwipeLeftAgent) {
                this.onSwipeLeftAgent();
            }
        }

        // swiped right
        if (this.touchEndX - this.sensitive >= this.touchStartX) {
            if (this.onSwipeRightAgent) {
                this.onSwipeRightAgent();
            }
        }

        // swiped up
        if (this.touchEndY + this.sensitive <= this.touchStartY) {
            if (this.onSwipeUpAgent) {
                this.onSwipeUpAgent();
            }
        }

        // swiped down
        if (this.touchEndY - this.sensitive >= this.touchStartY) {
            if (this.onSwipeDownAgent) {
                this.onSwipeDownAgent();
            }
        }

        // tap
        if (this.touchEndY === this.touchStartY) {
            if (this.onTapAgent) {
                this.onTapAgent();
            }
        }
    }
}
